import { useCart } from "../../../../app/context/cart-context/cart-context";
import { useEffect, useState } from "react";
import { motion, } from "framer-motion";

import "./quantity-selector.css";

import {ReactComponent as MinusIcon} from '../../../../assets/images/icons/minus.svg';
import {ReactComponent as PlusIcon} from '../../../../assets/images/icons/plus.svg';

export const QuantitySelector = ({ productId }) => {

    const {cart, updateCart} = useCart();
   
    const currentQuantity = parseFloat(cart.filter(item => item.id === productId)[0]?.qtt); 

    const [quantity, setQuantity] = useState(currentQuantity || 1);
    const [inputInit, setInit] = useState(false);

    const increment = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setQuantity(prevQuantity => prevQuantity + 1);
    }
    
    const decrement = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setQuantity(prevQuantity => prevQuantity > 1 ? prevQuantity - 1 : 0);
    }
    
    useEffect(() => {
        if (inputInit) {
            updateCart({id: productId, qty: quantity});
        } else {
            setInit(true);
        }
        
    }, [quantity]);
    
    
    return (
        <motion.div className="quantity-selector-wrap"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 0.3 } }}
            exit={{ opacity: 0, transition: { duration: 0.1 } }}
        >
            <button onClick={(e) => decrement(e)}>
               <MinusIcon/>
            </button>
            <span className="qty-field" onClick={(e) => {e.preventDefault(); e.stopPropagation()}}>{quantity}</span>
            <button onClick={(e) => increment(e)}>
                <PlusIcon/>
            </button>
            
        </motion.div>
    )
}